// extracted by mini-css-extract-plugin
export default {"googleButton":"styles_googleButton__2IqKp","appleButton":"styles_appleButton__m8tnF"};